import { render, staticRenderFns } from "./CompuertaPantalla.vue?vue&type=template&id=dab12ff0&scoped=true"
import script from "./CompuertaPantalla.vue?vue&type=script&lang=js"
export * from "./CompuertaPantalla.vue?vue&type=script&lang=js"
import style0 from "./CompuertaPantalla.vue?vue&type=style&index=0&id=dab12ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab12ff0",
  null
  
)

export default component.exports